import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChevronLeft, Construction } from "lucide-react";

const TITLES = {
  "/jobs": "Jobs",
  "/customers": "Customers",
  "/suppliers": "Suppliers",
  "/documents": "Documents",
};

export default function ComingSoon() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || "Module";

  return (
    <div data-testid="coming-soon-page" className="max-w-3xl">
      <Link to="/" className="text-xs text-slate-500 hover:text-slate-900 inline-flex items-center gap-1">
        <ChevronLeft className="h-3 w-3" /> Back to Home
      </Link>
      <h1 className="font-display text-3xl tracking-tight font-semibold text-slate-900 mt-3">{title}</h1>
      <Card className="rounded-sm border border-slate-200 shadow-none p-10 mt-6 text-center">
        <div className="h-14 w-14 mx-auto rounded-sm bg-amber-50 text-amber-700 flex items-center justify-center border border-amber-200">
          <Construction className="h-7 w-7" />
        </div>
        <h2 className="mt-5 font-display text-xl font-semibold text-slate-900">
          {title} — coming soon
        </h2>
        <p className="mt-3 text-sm text-slate-600 max-w-md mx-auto">
          This module is part of the new D4PS portal. Tell us what fields and actions you need
          and we'll build it next.
        </p>
        <Link to="/" className="inline-block mt-6">
          <Button className="rounded-sm bg-slate-900 hover:bg-slate-800 text-white">Back to Home</Button>
        </Link>
      </Card>
    </div>
  );
}
